/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getPriorityGroupDataByProjectIdQuery$variables = {
  projectAri: string;
};
export type getPriorityGroupDataByProjectIdQuery$data = {
  readonly queuesprioritygroups_priorityGroups: {
    readonly results: ReadonlyArray<{
      readonly category: string | null | undefined;
      readonly creationMethod: string | null | undefined;
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
      readonly queueIds: ReadonlyArray<number | null | undefined> | null | undefined;
      readonly version: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type getPriorityGroupDataByProjectIdQuery = {
  response: getPriorityGroupDataByProjectIdQuery$data;
  variables: getPriorityGroupDataByProjectIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectAri"
      }
    ],
    "concreteType": "QueuesPriorityGroupsResults",
    "kind": "LinkedField",
    "name": "queuesprioritygroups_priorityGroups",
    "plural": false,
    "selections": [
      {
        "concreteType": "QueuesPriorityGroupsResultsGroup",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          {
            "kind": "ScalarField",
            "name": "queueIds"
          },
          {
            "kind": "ScalarField",
            "name": "version"
          },
          {
            "kind": "ScalarField",
            "name": "creationMethod"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getPriorityGroupDataByProjectIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getPriorityGroupDataByProjectIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
    "metadata": {},
    "name": "getPriorityGroupDataByProjectIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e99dcef5a507344c549819dcfbf09d31";

export default node;
